import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import fill from 'lodash/fill';
import map from 'lodash/map';
export default {
  name: 'MdmPagination',
  props: {
    pageSize: {
      type: Number,
      default: 40
    },
    total: {
      type: Number,
      required: true
    },
    path: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      show: ''
    };
  },
  computed: {
    pagination: function pagination() {
      var currentPage = this.$route.query.page || 1;
      var a = fill(Array(Math.ceil(this.total / this.pageSize)), 1);
      var fullPagination = map(a, function (x, y) {
        return y + 1;
      }); // Premier, {x-100}, {x-50}, {x-40}, {x-30}, {x-20}, {x-10}, {x-5}, {x-4}, {x-3}, {x-2},
      // {x-1},  {x},  {x+1}, {x+2}, {x+3}, {x+4}, {x+5}, {x+10}, {x+20}, {x+30}, {x+40},
      // {x+50}, {x+100}, Dernier

      return fullPagination.filter(function (page, index) {
        return Math.abs(currentPage - page) < 6 || Math.abs(currentPage - page) % 10 === 0 && Math.abs(currentPage - page) / 10 < 6 || Math.abs(currentPage - page) % 100 === 0 || index === 0 || index === fullPagination.length - 1;
      });
    }
  },
  mounted: function mounted() {
    this.show = 'd-none';
  }
};